export const Mapstyles = Object.freeze({
  world: {
    pane: 'worldPane',
    fillColor: '#034761',
    fillOpacity: 1,
    weight: 0,
    className: 'nocursor',
  },
  officialBoundaries: {
    pane: 'officialBoundariesPane',
    radius: 8,
    fillColor: '#015e6d',
    color: '#02b0ae',
    opacity: 1,
    fillOpacity: 1,
    stroke: true,
    weight: 0.5,
  },
});
